module.exports = __webpack_public_path__ + "static/media/market-leader.0b33f724.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/market-leader.jpg
// module id = 2630
// module chunks = 0